import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { Phone, UserRound, X } from "lucide-react";
import { fetchUsers } from "../../redux/action";
import "./CustomerProfile.scss";

function CustomerProfile() {
  const { restaurantId, restaurant, id, table } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const customer = useSelector((state) => state.user.user);

  useEffect(() => {
    if (restaurantId) {
      dispatch(fetchUsers(restaurantId));
    }
  }, [dispatch, restaurantId]);

  if (!customer) {
    return (
      <main className="profile-page">
        <div className="profile-shell">
          <p className="profile-loading">Loading profile...</p>
        </div>
      </main>
    );
  }

  const handleClose = () => {
    navigate(`/${restaurant}/${id}/${table}/menu`);
  };

  return (
    <main className="profile-page">
      <div className="profile-shell">
      <div className="profile-header">
        <h1 className="profile-title">Your profile</h1>
        <button
          className="profile-close"
          onClick={handleClose}
          aria-label="Close profile"
          type="button"
        >
          <X size={20} aria-hidden="true" />
        </button>
      </div>

      <section className="profile-card" aria-label="Customer details">
        <div className="profile-avatar" aria-hidden="true">
          <UserRound size={42} strokeWidth={1.5} />
        </div>
        <h2 className="profile-name">{customer.name || "Guest"}</h2>
        <p className="profile-caption">Customer account</p>

        <div className="profile-details">
          <div className="profile-detail-icon" aria-hidden="true">
            <Phone size={18} />
          </div>
          <div className="profile-detail-copy">
            <span className="profile-detail-label">Contact number</span>
            <span className="profile-detail-value">
              {customer.contactNumber || "Not provided"}
            </span>
          </div>
        </div>
      </section>
      </div>
    </main>
  );
}

export default CustomerProfile;
